import { CSSProperties, PropsWithChildren, useEffect } from 'react'

import { Toaster } from '@hap/components'

window.globalTheme = 'light'
const DARK_THEME = 'dark'
const LIGHT_THEME = 'light'
const themes = [DARK_THEME, LIGHT_THEME]

export function PublicTemplate(
  props: PropsWithChildren<{ width?: number | string; style?: CSSProperties }>,
) {
  useEffect(() => {
    const root = window.document.documentElement
    root.classList.remove(...themes)

    const osColorSchemeChange = (event: MediaQueryListEvent) => {
      root.classList.remove(...themes)
      if (event.matches) {
        root.classList.add(DARK_THEME)
      } else {
        root.classList.add(LIGHT_THEME)
      }
    }

    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      root.classList.add(DARK_THEME)
    } else {
      root.classList.add(LIGHT_THEME)
    }

    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', osColorSchemeChange)

    return () => {
      window
        .matchMedia('(prefers-color-scheme: dark)')
        .removeEventListener('change', osColorSchemeChange)
    }
  }, [])

  return (
    <div className="gutters flex min-h-screen flex-col items-center justify-between select-none">
      <style>{`
        :root {
          --background: oklch(0.9516 0.0026 106.449997);
          --accent: oklch(1 0 0);
        }

        .dark {
          --background: oklch(21.41% 0.001 2.4);
          --accent: oklch(27.22% 0.005 271);
        }
`}</style>
      <div className="p-4">
        <Toaster />
        <svg
          width="110"
          viewBox="0 0 430 121"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 1.99988H22V35.9999C27.3676 29.7482 34.1349 25.1416 42.6542 25.1416C56.1401 25.1416 63 33.4771 63 47.5047V95.9934L41 95.9999V51.9999C41 47.0024 38.689 42.9999 32.5 42.9999C28.5077 42.9999 24.3495 45.4756 22 46.9999V95.9999H0V1.99988Z"
            className="fill-foreground"
          ></path>
          <path
            d="M110 49C110 43.8675 106.106 40.5584 99.783 40.5584C93.8615 40.5584 85.6095 42.6423 78.4655 45.8453L73.9192 30.6986C86.5646 26.3958 94.7273 25 103.4 25C120.457 25 132 33.4129 132 48V96L111.894 95.9935L109.697 88.7771C103.775 95.1638 97.0627 97 89.8995 97C78.4767 97 70.5 90.4365 70.5 79.3224C70.5 62.6514 86.0655 54.9295 110 53V49ZM110 64C99.685 64.9648 93 68.7324 93 74C93 78.4379 96.4784 80.4223 100.184 80.4223C103.622 80.4223 107.517 79.3733 110 77V64Z"
            className="fill-foreground"
          ></path>
          <path
            d="M165.345 33.4771C169.051 28.6147 175.794 25.1416 182.269 25.1416C200.703 25.1416 208 41.5505 208 61C208 80.4495 199.433 97 181 97C175.078 97 169.07 94.6042 165.345 89.7418H165V121H143V26H163L165.059 33.4771H165.326H165.345ZM165 76C166.509 77.2542 169.758 79.3224 173.75 79.3224C181.047 79.3224 185 72.2491 185 61C185 49.7509 181.028 43.2019 173.75 43.2019C169.758 43.2019 166.509 44.7458 165 46V76Z"
            className="fill-foreground"
          ></path>
          <path
            d="M165.254 33.3355C168.944 28.4731 175.551 25 182 25C200.358 25 208 41.5505 208 61C208 80.4495 199.202 96.8584 180.845 96.8584C174.947 96.8584 168.963 94.4626 165.254 89.6002H165V121H143V26H163L164.968 33.3355H165.235H165.254ZM164.987 76.1322C166.49 77.3864 169.648 79.1808 173.624 79.1808C180.891 79.1808 185 72.3696 185 61.1206C185 49.8715 181.248 43 174 43C170.024 43 166.49 45.0091 164.987 46.2633V76.1322Z"
            className="fill-foreground"
          ></path>
          <path
            d="M239.254 33.3355C242.944 28.4731 249.551 25 256 25C274.358 25 282 41.5505 282 61C282 80.4495 273.202 96.8584 254.845 96.8584C248.947 96.8584 242.963 94.4626 239.254 89.6002H239V121H217V26H237L238.968 33.3355H239.235H239.254ZM238.987 76.1322C240.49 77.3864 243.648 79.1808 247.624 79.1808C254.891 79.1808 259 72.3696 259 61.1206C259 49.8715 255.248 43 248 43C244.024 43 240.49 45.0091 238.987 46.2633V76.1322Z"
            className="fill-foreground"
          ></path>
          <path
            d="M302 0C309.985 0 315 3.18881 315 10C315 16.8112 309.965 20 302 20C294.035 20 289 16.9463 289 10C289 3.05374 294.035 0 302 0ZM291.054 96V26H313V96H291.054Z"
            className="fill-foreground"
          ></path>
          <path
            d="M348 75.7142C348 79.6118 351.415 80.8467 354.166 80.8467C355.408 80.8467 358.491 80.4245 360 80V96C355.74 96.6946 348.206 97 344.5 97C329.772 97 326 89.8086 326 78V43H319V28L326 27V7H348V26H360V43H348V75.6949V75.7142Z"
            className="fill-foreground"
          ></path>
          <path
            d="M429.962 95.9934H409.891L407.695 87.3877H407.428C401.928 93.7744 395.528 97 387.011 97C373.529 97 367 89.0276 367 75V26H389V71C389 75.9974 391.313 79 397.5 79C401.358 79 405.651 76.5243 408 75V26H430V95.9934H429.962Z"
            className="fill-foreground"
          ></path>
        </svg>
      </div>
      <div
        className="flex w-full"
        style={{ maxWidth: props.width || 330, ...(props.style || {}) }}
      >
        <div className="w-full pt-10 pb-20">{props.children}</div>
      </div>
      <div className="text-accent-foreground shrink-0 grow-0 space-x-4 p-6 text-sm">
        <span>&copy; {new Date().getFullYear()} Happitu, LLC</span>
        <a href="//happitu.com/legal/terms" target="_blank">
          Terms
        </a>
        <a href="//happitu.com/legal/privacy" target="_blank">
          Privacy
        </a>
        <a href="mailto:help@happitu.com">Support</a>
      </div>
    </div>
  )
}
